.ratingDots {
  overflow: visible;
}
